import BankrateIcon from '@mortgage-pos/ui/assets/bankrate/BR_logo.svg'
import BalancedIcon from '@mortgage-pos/ui/assets/Balanced.svg'
import NoPointsIcon from '@mortgage-pos/ui/assets/No_Points.svg'
import MaxCashoutIcon from '@mortgage-pos/ui/assets/Max_Cash_Out.svg'
import ZeroUpfrontIcon from '@mortgage-pos/ui/assets/Zero_Upfront.svg'
import LowestRateIcon from '@mortgage-pos/ui/assets/lowest-rate-icon.svg'
import RecommendedIcon from '@mortgage-pos/ui/assets/recommended-icon.svg'
import FasterPayoffIcon from '@mortgage-pos/ui/assets/faster-payoff-icon.svg'
import LowestMonthlyPaymentIcon from '@mortgage-pos/ui/assets/low-monthly-payment-icon.svg'

export enum rateCompareCalculations {
  monthlyPayment = 'monthlyPayment',
  lifeOfLoan = 'lifeOfLoan',
  upfrontCost = 'upfrontCost',
  cashOut = 'cashOut',
}

export const RATE_SUPERLATIVES = {
  bankrate: {
    icon: BankrateIcon,
    heading: 'YOUR SELECTED RATE',
  },
  lowerPayment: {
    icon: LowestMonthlyPaymentIcon,
    heading: 'LOWER MONTHLY PAYMENT',
    compareValueProp: 'Save {x} on your monthly payment',
    valuePropCalculation: rateCompareCalculations.monthlyPayment,
  },
  fasterPayoff: {
    icon: FasterPayoffIcon,
    heading: 'FASTER PAYOFF',
    description:
      'Own your home sooner and save thousands in interest—this option helps you build equity faster while keeping payments manageable.',
    compareValueProp: 'Save {x} over the life of the loan',
    valuePropCalculation: rateCompareCalculations.lifeOfLoan,
  },
  lowerInterestRate: {
    icon: LowestRateIcon,
    heading: 'LOWER RATE',
    compareValueProp: 'Save {x} over the life of the loan',
    valuePropCalculation: rateCompareCalculations.lifeOfLoan,
  },
  cashOut: {
    icon: MaxCashoutIcon,
    heading: 'CASH OUT OPTION',
    compareValueProp: 'Tap in to equity with {x} cash out',
    valuePropCalculation: rateCompareCalculations.cashOut,
  },
  zeroUpfront: {
    icon: ZeroUpfrontIcon,
    heading: 'ZERO UPFRONT COSTS',
    compareValueProp: 'This offer will cost you $0 in closing fees',
  },
  balanced: {
    icon: BalancedIcon,
    heading: 'BALANCED OPTION',
    description:
      'A smart choice for long-term stability—get a lower monthly payment while locking in a competitive fixed rate for 30 years.',
    compareValueProp: 'Save {x} over the life of the loan',
    valuePropCalculation: rateCompareCalculations.lifeOfLoan,
  },
  noPoint: {
    icon: NoPointsIcon,
    heading: 'NO POINT OPTION',
    description:
      'No upfront points means less cash towards closing costs - great if you plan to refinance or move within a few years.',
    compareValueProp: 'Save {x} in upfront cost of the loan',
    valuePropCalculation: rateCompareCalculations.upfrontCost,
  },
  default: {
    icon: RecommendedIcon,
    heading: 'ADDITIONAL OPTION',
    compareValueProp: 'Save {x} over the life of the loan',
    valuePropCalculation: rateCompareCalculations.lifeOfLoan,
  },
  currentLoan: {
    icon: '',
    heading: 'Your current loan',
  },
  // TODO For BR POC, remove
  interest: {
    icon: FasterPayoffIcon,
    heading: 'ADDITIONAL OPTION',
    compareValueProp: 'Save from this alternative provider',
  },
  otherLender: {
    icon: '',
    heading: 'Other Lender',
  },
}
